<template>
  <div id="app">
    <router-view />
    <c-notifications
      @close="close"
      :notifications="notifications"
    />
  </div>
</template>

<script>
import { NOTIFICATIONS, NOTIFICATIONS_EXCLUDE } from '@store/types'
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: mapGetters({
    notifications: NOTIFICATIONS
  }),
  created () {
    this.notifications.forEach(it => this.close(it))
  },
  methods: mapActions({
    close: NOTIFICATIONS_EXCLUDE
  })
}
</script>

<style lang="scss" src="@styles/style.scss"></style>



// WEBPACK FOOTER //
// src/App.vue